/**
 * @file courseTaking.js
 * @author Jake Stark
 * @desc Course Taking report plugin

*/

/**
 * @module courseTaking
 * @desc courseTaking report plugin
 */

define('plugins/courseTaking',["underscore", "models",
        "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/courseTaking_langArts_table.html", "text!plugins/templates/courseTaking_math_table.html",
        "text!plugins/templates/courseTaking_science_table.html", "text!plugins/templates/courseTaking_socialStudies_table.html",
        "text!plugins/templates/courseTaking_basicArts_table.html", "text!plugins/templates/courseTaking_worldLanguages_table.html", "text!plugins/templates/courseTaking_phyEd_table.html", "cardboard/pluginPieces"
    ],
    function (_, SLEDSModels,
        CardboardModels, CardboardCollections, Util,
        langArtsTemplate, mathTemplate, scienceTemplate, socialStudiesTemplate,
        basicArtsTemplate, worldLanguagesTemplate, phyEdTemplate, PluginPieces) {

        console.log("MODULE: courseTaking");

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                forcedSummaryFilters: ["courseTakingCOHORTID"],
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "Language Arts",
                    explanationText: "<p>Language Arts - This report shows the number and percent of students that took the graduation requirement of 4 credit years or more.</p>",
                    openByDefault: true,
                    views: [{
                            type: "template",
                            template: "<h5>HS graduates who took Language Arts courses</h5>",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "languageArts.data",
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "name",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            series: [{
                                    valuePath: "slice[0].percent",
                                    seriesDisplayName: "Dev Ed",
                                },
                                {
                                    valuePath: "slice[1].percent",
                                    seriesDisplayName: "No Dev Ed"
                                }
                            ],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "The selected criteria resulted in counts too small to report."
                                }
                            }]
                         
                        },
                        {
                            type: "template",
                            template: langArtsTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.languageArts.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                    ]
                },
                {
                    title: "Math",
                    explanationText: "<p>Math – This report shows the number and percent of students that took the graduation requirement of 3 credit years or more.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>HS graduates who took Math courses</h5>",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "math.data",
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "name",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            series: [{
                                    valuePath: "slice[0].percent",
                                    seriesDisplayName: "Dev Ed",
                                },
                                {
                                    valuePath: "slice[1].percent",
                                    seriesDisplayName: "No Dev Ed"
                                }
                            ],

                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "The selected criteria resulted in counts too small to report."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: mathTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.math.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                    ]
                },
                {
                    title: "Science",
                    explanationText: "<p>Science – This report shows the number and percent of students that took the graduation requirement of 3 credit years or more.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>HS graduates who took Science courses</h5>",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "science.data",
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "name",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            series: [{
                                    valuePath: "slice[0].percent",
                                    seriesDisplayName: "Dev Ed",
                                },
                                {
                                    valuePath: "slice[1].percent",
                                    seriesDisplayName: "No Dev Ed"
                                }
                            ],

                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "The selected criteria resulted in counts too small to report."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: scienceTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.science.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                    ]
                },
                {
                    title: "Social Studies",
                    explanationText: "<p>Social Studies – This report shows the number and percent of students that took the graduation requirement of 2 credit years or more.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>HS graduates who took Social Studies courses</h5>",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "socialStudies.data",
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "name",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            series: [{
                                    valuePath: "slice[0].percent",
                                    seriesDisplayName: "Dev Ed",
                                },
                                {
                                    valuePath: "slice[1].percent",
                                    seriesDisplayName: "No Dev Ed"
                                }
                            ],

                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "The selected criteria resulted in counts too small to report."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: socialStudiesTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.socialStudies.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                    ]
                },
                {
                    title: "Basic Arts",
                    explanationText: "<p>Arts – This report shows the number and percent of students that took the graduation requirement of 1 credit years or more.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>HS graduates who took Basic Arts courses</h5>",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "basicArts.data",
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "name",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            series: [{
                                    valuePath: "slice[0].percent",
                                    seriesDisplayName: "Dev Ed",
                                },
                                {
                                    valuePath: "slice[1].percent",
                                    seriesDisplayName: "No Dev Ed"
                                }
                            ],

                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "The selected criteria resulted in counts too small to report."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: basicArtsTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.basicArts.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                    ]
                },
                {
                    title: "World Languages",
                    explanationText: "<p>World Languages – This report shows the number and percent of students that took the graduation requirement of 0 credit years or more.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>HS graduates who took World Languages courses</h5>",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "worldLanguages.data",
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "name",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            series: [{
                                    valuePath: "slice[0].percent",
                                    seriesDisplayName: "Dev Ed",
                                },
                                {
                                    valuePath: "slice[1].percent",
                                    seriesDisplayName: "No Dev Ed"
                                }
                            ],

                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "The selected criteria resulted in counts too small to report."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: worldLanguagesTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.worldLanguages.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]

                        },
                    ]
                },
                {
                    title: "Physical Education and Health",
                    explanationText: "<p>Physical Education and Health – This report shows the number and percent of students that took the graduation requirement of 1 credit years or more.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>HS graduates who took Physical Education and Health courses</h5>",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "physicalEducationAndHealth.data",
                            dataShape: "pointsAcrossRows",
                            convertDataHashToArray: true,
                            dataDimensions: 2,
                            xAxisLabelPath: "name",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            series: [{
                                    valuePath: "slice[0].percent",
                                    seriesDisplayName: "Dev Ed",
                                },
                                {
                                    valuePath: "slice[1].percent",
                                    seriesDisplayName: "No Dev Ed"
                                }
                            ],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "The selected criteria resulted in counts too small to report."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: phyEdTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.physicalEducationAndHealth.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                    ]
                },
                {
                    title: "More Information",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: "<p>The Minnesota Common Course Catalogue (MCCC) is a course classification and data collection system intended to provide uniform information about courses that are taught by Minnesota teachers and completed by Minnesota students. For more information on the catalogue, information reported, and other resources, please visit the <a href='https://education.mn.gov/MDE/dse/datasub/MCCC/' target='_blank'>MCCC webpage</a> on the Minnesota Department of Education's website. </p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031879&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all high schools and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_hsgrad_orgid.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion.fex",
                    enabled: true
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_coursetakingcohortid.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },
                 filters3: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_coursetaking_dropdowns.fex"
                    },
                    enabled: true,
                }, 
                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_coursetakingbuttons.fex",
                    enabled: true,
                    noViewParams: false
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.Model,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_coursetaking.fex",
                    //url: "data/courseTaking.json",
                    yearPath: "dataYear",
                    defaultParams: {
                        orgId: 999999000
                    },
                    paramMappings: {
                        HSGRAD_ORGID: "orgId",
                        groupType: null, // skip this
                        COHORTID: "courseTakingCOHORTID",
                        orgName: null
                    },

                    enabled: true,
                    errorConditions: [
                        {
                            valuePath: "errorMessage",
                            isNot: null,
                            error: {
                                type: "NoData",
                                message: "Data is not available for current selection(s)."
                            }
                        }
                    ]
                }
            }
        };

        return exports;
    });
